export default __webpack_public_path__ + "static/media/generator.53c89ea4.svg";